(function () {
  // Vela: drawer is open when <html> or <body> has .jsDrawerOpenRight
  const HTML = document.documentElement;
  const BODY = document.body;

  function isOpen() {
    return HTML.classList.contains('jsDrawerOpenRight') || BODY.classList.contains('jsDrawerOpenRight');
  }

  function getDrawer() {
    return document.querySelector('#cartDrawer') || document.querySelector('.drawerRight') || null;
  }
  function getCloseBtn() {
    return document.querySelector('.jsDrawerClose') ||
           document.querySelector('.drawer__close') ||
           document.querySelector('.cartDrawerClose') ||
           document.querySelector('.btnCloseCart');
  }

  function safeClose() {
    if (!isOpen()) return;
    const btn = getCloseBtn();
    if (btn) { btn.click(); return; }
    HTML.classList.remove('jsDrawerOpenRight');
    BODY.classList.remove('jsDrawerOpenRight');
  }

  // --- State & guards
  let armed = false;
  let openedAt = 0;
  let lastOpenerClick = 0;

  // Track whether the pointer/touch is currently inside the drawer
  let pointerInDrawer = false;
  let touchInDrawer = false;

  document.addEventListener('click', function (e) {
    if (e.target.closest('.velaCartModal, .headerCartModal, [data-cart-drawer-open], a[href="/cart"]')) {
      lastOpenerClick = Date.now();
    }
  }, { passive: true });

  // Listener refs
  let onScroll, onWheel, onTouchMove, onPointerDown, onKeydown, onPointerEnter, onPointerLeave, onTouchStart, onTouchEnd;

  function arm() {
    if (armed) return;
    armed = true;
    openedAt = Date.now();

    const drawer = getDrawer();

    // Track pointer/touch being inside the drawer
    if (drawer) {
      onPointerEnter = () => { pointerInDrawer = true; };
      onPointerLeave = () => { pointerInDrawer = false; };
      drawer.addEventListener('pointerenter', onPointerEnter, { passive: true });
      drawer.addEventListener('pointerleave', onPointerLeave, { passive: true });

      onTouchStart = (e) => { if (drawer.contains(e.target)) touchInDrawer = true; };
      onTouchEnd   = () => { touchInDrawer = false; };
      drawer.addEventListener('touchstart', onTouchStart, { passive: true });
      drawer.addEventListener('touchend', onTouchEnd, { passive: true });
      drawer.addEventListener('touchcancel', onTouchEnd, { passive: true });
    }

    // 1) Close on page scroll (but not if user is interacting inside drawer)
    onScroll = function () {
      if (!isOpen()) return;
      if (Date.now() - openedAt < 300) return;
      if (pointerInDrawer || touchInDrawer) return;
      safeClose();
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // 2) Close on wheel outside the drawer (covers inner scrollers)
    onWheel = function (e) {
      if (!isOpen()) return;
      if (Date.now() - openedAt < 300) return;
      const d = getDrawer();
      if (d && d.contains(e.target)) return; // ignore wheel inside drawer
      safeClose();
    };
    document.addEventListener('wheel', onWheel, { passive: true });

    // 3) Close on touchmove outside the drawer (mobile)
    onTouchMove = function (e) {
      if (!isOpen()) return;
      if (Date.now() - openedAt < 300) return;
      const d = getDrawer();
      if (d && d.contains(e.target)) return; // ignore swipe inside drawer
      if (touchInDrawer) return;
      safeClose();
    };
    document.addEventListener('touchmove', onTouchMove, { passive: true });

    // 4) Click/tap outside
    onPointerDown = function (e) {
      if (!isOpen()) return;
      if (Date.now() - openedAt < 150 || Date.now() - lastOpenerClick < 300) return;
      const d = getDrawer();
      if (d && !d.contains(e.target)) safeClose();
    };
    document.addEventListener('pointerdown', onPointerDown, { passive: true });

    // 5) Esc
    onKeydown = function (e) {
      if (e.key === 'Escape' && isOpen()) safeClose();
    };
    document.addEventListener('keydown', onKeydown);
  }

  function disarm() {
    if (!armed) return;
    armed = false;

    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('wheel', onWheel);
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('pointerdown', onPointerDown);
    document.removeEventListener('keydown', onKeydown);

    const drawer = getDrawer();
    if (drawer) {
      drawer.removeEventListener('pointerenter', onPointerEnter);
      drawer.removeEventListener('pointerleave', onPointerLeave);
      drawer.removeEventListener('touchstart', onTouchStart);
      drawer.removeEventListener('touchend', onTouchEnd);
      drawer.removeEventListener('touchcancel', onTouchEnd);
    }

    onScroll = onWheel = onTouchMove = onPointerDown = onKeydown =
      onPointerEnter = onPointerLeave = onTouchStart = onTouchEnd = null;

    pointerInDrawer = false;
    touchInDrawer = false;
  }

  // Observe open/close class toggles
  if (window.MutationObserver) {
    const observe = (el) => {
      const mo = new MutationObserver(() => { if (isOpen()) arm(); else disarm(); });
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
      if (isOpen()) arm();
    };
    observe(HTML);
    observe(BODY);
  } else {
    setInterval(() => { if (isOpen()) arm(); else disarm(); }, 200);
  }
})();
